export default function Contact() {
  return (
    <section className="py-16 overflow-x-hidden">
      {/* Header */}
      <div className="mx-auto max-w-6xl px-4">
        <div className="flex flex-col gap-4 min-w-0">
          <div className="flex items-center gap-3">
            <span className="h-[2px] w-10 rounded-full bg-[color:var(--c1)]" />
            <span className="text-xs font-medium tracking-wide text-[color:var(--muted)]">
              Contáctanos
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight leading-[1.05] break-words">
            Agenda tu evaluación{" "}
            <span className="text-[color:var(--c1)]">y visítanos</span>
          </h2>

          <p className="max-w-2xl text-base md:text-lg text-[color:var(--muted)] leading-relaxed">
            Estamos para ayudarte con un plan dermatológico personalizado. Escríbenos por WhatsApp,
            llámanos o visítanos en consulta.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="mx-auto mt-10 max-w-6xl px-4">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* Left: Contact card */}
          <div className="min-w-0 rounded-[28px] border border-[color:var(--border)] bg-[color:var(--c2)] p-4 sm:p-6 md:p-8 shadow-[0_14px_40px_rgba(0,0,0,0.06)]">
            <div className="min-w-0 rounded-[24px] border border-[color:var(--border)] bg-white/70 p-4 sm:p-6 md:p-7 backdrop-blur">
              <div className="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div className="min-w-0">
                  <h3 className="text-lg sm:text-xl font-semibold break-words">
                    BELSKIN NURSE
                  </h3>
                  <p className="mt-1 text-sm text-[color:var(--muted)] break-words">
                    Dermoestética · Estética · Cuidado de la piel
                  </p>
                </div>

                <div className="hidden sm:flex items-center gap-2 shrink-0">
                  <span className="inline-flex items-center gap-2 rounded-full border border-[color:var(--border)] bg-white/60 px-3 py-1 text-xs text-[color:var(--muted)]">
                    Respuesta rápida
                    <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--c2)]" />
                  </span>
                </div>
              </div>

              <div className="mt-6 grid gap-3 min-w-0">
                <ContactRow
                  icon={<PhoneIcon />}
                  title="Teléfono y WhatsApp"
                  value="+56 9 2091 0798"
                  href="tel:+56920910798"
                />
                <ContactRow
                  icon={<MailIcon />}
                  title="Correo"
                  value="info.belskin@gmail.com"
                  href="mailto:info.belskin@gmail.com"
                />
                <ContactRow
                  icon={<PinIcon />}
                  title="Nos encuentras en Clínica Cualtzin"
                  value="El Atardecer 3891, El Rosario de Peñuelas, Coquimbo"
                  href="https://www.google.com/maps/place/Cl%C3%ADnica+Est%C3%A9tita+Cualtzin/@-29.9668708,-71.3018178,17z/data=!3m1!4b1!4m6!3m5!1s0x9691cb0a5e3499e9:0xc8a388c39f32a2a8!8m2!3d-29.9668708!4d-71.3018178!16s%2Fg%2F11h_zpfq1d?entry=ttu&g_ep=EgoyMDI2MDMwMi4wIKXMDSoASAFQAw%3D%3D"
                />
              </div>

              {/* Hours */}
              <div className="mt-6 min-w-0 rounded-2xl border border-[color:var(--border)] bg-white/60 p-4">
                <div className="flex items-start gap-3 min-w-0">
                  <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[color:var(--border)] bg-white/70">
                    <ClockIcon />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold">Horario</p>
                    <p className="text-sm text-[color:var(--muted)] break-words">
                      Lun a Sab: 10:00 – 19:00
                    </p>
                  </div>
                </div>
              </div>

              <p className="mt-5 text-xs text-[color:var(--muted)]">
                * Si necesitas ayuda, contáctanos por WhatsApp.
              </p>
            </div>
          </div>

          {/* Right: Map */}
          <div className="min-w-0 rounded-[28px] border border-[color:var(--border)] bg-[color:var(--c1)] p-4 sm:p-6 md:p-8 shadow-[0_14px_40px_rgba(0,0,0,0.06)]">
            <div className="min-w-0 overflow-hidden rounded-[24px] border border-[color:var(--border)] bg-white/70 backdrop-blur">
              <div className="p-4 sm:p-5 border-b border-[color:var(--border)] min-w-0">
                <p className="text-sm font-semibold">Cómo llegar</p>
                <p className="text-sm text-[color:var(--muted)] break-words">
                  Encuéntranos en Google Maps y planifica tu visita.
                </p>
              </div>

              <div className="aspect-[16/11] w-full">
                <iframe
                  title="Mapa Clínica"
                  className="h-full w-full border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  src="https://www.google.com/maps?q=-29.9668708,-71.3018178&z=17&output=embed"
                />
              </div>

              <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 border-t border-[color:var(--border)] p-4 sm:p-5 min-w-0">
                <a
                  href="https://www.google.com/maps"
                  target="_blank"
                  rel="noreferrer"
                  className="
                    inline-flex w-full sm:w-auto items-center justify-center gap-2
                    rounded-xl px-4 py-2 text-sm font-medium
                    border border-[color:var(--border)]
                    bg-white/70 hover:bg-white transition
                  "
                >
                  <MapIcon />
                  Abrir en Maps
                </a>

                <span className="inline-flex w-full sm:w-auto items-center justify-center rounded-xl px-4 py-2 text-sm bg-white/60 border border-[color:var(--border)] text-[color:var(--muted)] text-center">
                  Acceso fácil · Zona segura
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactRow({ icon, title, value, href }) {
  return (
    <a
      href={href}
      target={href?.startsWith("http") ? "_blank" : undefined}
      rel={href?.startsWith("http") ? "noreferrer" : undefined}
      className="
        group flex min-w-0 items-start gap-3 rounded-2xl
        border border-[color:var(--border)]
        bg-white/60 p-4
        hover:-translate-y-[1px]
        hover:bg-white/80
        hover:shadow-[0_10px_22px_rgba(0,0,0,0.06)]
        transition
      "
    >
      <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-[color:var(--border)] bg-white/70">
        <span className="text-[color:var(--c1)]">{icon}</span>
      </div>

      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold break-words">{title}</p>
        <p className="text-sm text-[color:var(--muted)] group-hover:text-[color:var(--ink)] transition break-words">
          {value}
        </p>
      </div>
    </a>
  );
}

/* ===== Icons ===== */

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3 5.18 2 2 0 0 1 5.11 3h3a2 2 0 0 1 2 1.72c.12.86.3 1.7.54 2.5a2 2 0 0 1-.45 2.11L9.09 10.91a16 16 0 0 0 4 4l1.58-1.58a2 2 0 0 1 2.11-.45c.8.24 1.64.42 2.5.54A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 4h16v16H4z" />
      <path d="M4 6l8 6 8-6" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 21s7-4.35 7-11a7 7 0 0 0-14 0c0 6.65 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6l4 2" />
    </svg>
  );
}

function MapIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 18l-6 3V6l6-3 6 3 6-3v15l-6 3-6-3z" />
      <path d="M9 3v15" />
      <path d="M15 6v15" />
    </svg>
  );
}